<template>
  <section>
    <div v-if="(isHome() || isViewAllPage()) && !isMyProfile()"
         class="banner-background">
      <div class="data-container column-view">
        <div class="logo-container">
          <img src="https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/banners%2FSigmaxi%2FSigmaxi%20banner%20logo.png?alt=media&token=cbe63b94-ee33-4444-b476-89c01ff113f0"
               class="logo-container_img">
        </div>
        <div class="line-container">
          <img src="https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/banners%2FSigmaxi%2FLine%202.png?alt=media&token=7238f7d6-ab40-472c-b234-5be3e6ce6fe7"
               />
        </div>
        <div class="text-container">
          <img src="https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/banners%2FSigmaxi%2FBanner%20header%20text.png?alt=media&token=2ba6444d-6fa3-429f-b01e-10689d516d50"/>
          <p class="description-container">Explore and engage on projects from Sigma Xi's bright young minds who go above and beyond through their scientific research</p>
          <div class="sponsor-container">
            <div class="sponsor-text">
              <p>Sponsored By:</p>
            </div>
            <div class="sponsor-image">
              <img src="https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/banners%2FSigmaxi%2FAthena_primary%20(1).png?alt=media&token=c6a7471d-e741-49aa-a8c2-66d474ef3b25"/>
            </div>
          </div>
        </div>
      </div>
      <div class="data-container row-view">
        <div class="logo-container">
          <img src="https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/banners%2FSigmaxi%2FSigmaxi%20banner%20logo.png?alt=media&token=cbe63b94-ee33-4444-b476-89c01ff113f0"
               class="logo-container_img">
        </div>
        <div class="line-container">
          <img src="https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/banners%2FSigmaxi%2FLine%201.png?alt=media&token=b390767d-f1d4-435f-9cbd-afb073a3530f"
          />
        </div>
        <div class="text-container">
          <img src="https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/banners%2FSigmaxi%2FFrame%201000004600.png?alt=media&token=5b7d7005-65ae-44d9-877b-13e173879998"/>
          <div class="sponsor-container">
            <div class="sponsor-text">
              <p>Sponsored By:</p>
            </div>
            <div class="sponsor-image">
              <img src="https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/banners%2FSigmaxi%2FAthena_primary%20(1).png?alt=media&token=c6a7471d-e741-49aa-a8c2-66d474ef3b25"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>

export default {
  methods: {
    isHome: function () {
      return this.$route.fullPath.includes('home')
    },
    isViewAllPage: function () {
      return this.$route.fullPath.includes('viewAll')
    },
    isMyProfile: function () {
      return this.$route.fullPath.includes('profile')
    }
  }
}

</script>
<style lang="scss" scoped>
@import '~styles/utils.scss';
.banner-background {
  justify-content: center;
  align-items: center;
  background-image: url("https://firebasestorage.googleapis.com/v0/b/project-leo-mvp.appspot.com/o/banners%2FSigmaxi%2FSigmaxi%20banner%20bg.png?alt=media&token=e1ba1a78-fbcc-46b0-bcbe-9048d26614fb");
  height: 450px;
  background-size: cover;
  background-position: center;
}
.logo-container {
  height: 10rem;
  width: 15rem;
  margin-top: 150px;
  @media (max-width: 1024px) {
    height: 12rem;
    width: 12rem;
    margin-top: 190px;
  }
  @media (max-width: 820px) {
    height: 10rem;
    width: 10rem;
    margin-top: 210px;
  }
  @media (max-width: 400px) {
    height: 7.5rem;
    width: 7.5rem;
    margin-left: auto;
    margin-right: auto;
    margin-top: 140px;
  }
}
.line-container {
  margin-left: 2rem;
  height: 5px;
  width: 5px;
  margin-top: 170px;
  @media (max-width: 1024px) {
    height: 4px;
    width: 4px;
    margin-left: 1rem;
    margin-right: 0.5rem;
    margin-top: 200px;
  }
  @media (max-width: 820px) {
    height: 3.5px;
    width: 3.5px;
    margin-left: 0.8rem;
    margin-top: 218px;
  }
  @media (max-width: 414px) {
    height: 3.5px;
    width: 3.5px;
    margin-left: 1rem;
    margin-top: 218px;
  }
  @media (max-width: 400px) {
    height: 25px;
    width: 170px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 6px;
  }
}
.text-container {
  margin-top: 10rem;
  height: 50px;
  width: 27rem;
  margin-left: 2rem;
  @media (max-width: 1024px) {
    height: 50px;
    width: 20rem;
    margin-top: 12rem;
    margin-left: 1rem;
  }
  @media (max-width: 820px) {
    height: 50px;
    width: 20rem;
    margin-top: 12rem;
    margin-left: 1rem;
  }
  @media (max-width: 510px) {
    height: 50px;
    width: 10.5rem;
    margin-left: 1rem;
    margin-top: 12.5rem;
  }
  @media (max-width: 400px) {
    height: 30px;
    width: 17rem;
    margin-left: auto;
    margin-right: auto;
    margin-top: 0rem;
  }
}
.sponsor-container {
  width: 12rem;
  margin-top: 0rem;
  display: flex;
  @media (max-width: 510px) {
    width: 10rem;
  }
  @media (max-width: 400px) {
    margin-top: -0.5rem;
    margin-left: 3rem;
    align-content: center;
  }
}
.sponsor-text {
  color: white;
  font-weight: 300;
  font-size: 1.2rem;
  margin-top: 1.5rem;
  width: 12rem;
  @media (max-width: 1024px) {
    font-size: 1rem;
  }
  @media (max-width: 820px) {
    font-size: 1rem;
  }
  @media (max-width: 510px) {
    font-size: 0.8rem;
  }
}
.sponsor-image {
  width: 6rem;
  margin-top: 0.5rem;
}
.data-container {
  width: 100vw;
  margin-top: -5rem;
  display: flex;
  flex-direction: row;
  justify-content: center;
  @media (max-width: 1024px) {
    margin-top: -8rem;
  }
  @media (max-width: 400px) {
    flex-direction: column;
  }
}
.column-view {
  @media (max-width: 400px) {
    display: None;
  }
}
.row-view {
  @media (min-width: 401px) {
    display: None;
  }
}
.description-container {
  color: white;
  font-weight: 300;
  font-size: 1.2rem;
  @media (max-width: 1024px) {
    font-size: 1rem;
  }
  @media (max-width: 820px) {
    font-size: 1rem;
  }
  @media (max-width: 510px) {
    font-size: 0.8rem;
  }
  @media (max-width: 390px) {
    font-size: 0.7rem;
  }
  @media (max-width: 360px) {
    font-size: 0.6rem;
  }
  @media (max-width: 325px) {
    font-size: 0.4rem;
  }
}
@include mobile {
  .banner-logo {
    width: 15rem;
  }
  .banner-text {
    font-size: 3rem;
  }
}
</style>
